module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "epigraph",
    attrs: {
      "epub:type": "epigraph"
    }
  }, [_c('blockquote', {
    staticClass: " bq"
  }, [_c('p', {
    staticClass: "margin_top_newsection firstInSection"
  }, [_vm._v("Conticuere omnes intentique ora tenebant. inde toro pater Aeneas sic orsus ah alto: infandum, regina, iubes renovare dolorem, Troianas ut opes et lamentabile regnum eruerint Danai, quaeque ipse miserrima Uidi et quorum pars magna fui. quis talia fando Myrmidonum Dolopumve aut duri miles ulixi temperet a lacrimis? et iam nox umida caelo praecipitat suadentque cadentia sidera somnos. sed si tantus amor casus cognoscere nostros et breviter Troiae supremum audire laborem, quamquam animus meminisse horret luctuque refugit,incipiam.")]), _vm._v(" "), _c('p', {
    staticClass: "margin_top"
  }, [_vm._v("They all fell silent, each face turned intently towards him. Then from his couch high up, father Aeneas began: ‘You bid me, O queen, revive an unutterable sorrow; how the Greeks erased Troy and its magnificence, ever worth mourning. I saw that tragedy myself, indeed I was at its core. No one, not even a Myrmidon or a Dolopian, not even some soldier of unpitying Ulysses could tell this tale and fail to weep. Well, the damp air of night is fading swiftly from the sky. The setting stars remind us that we too must sleep. But if you really want to learn what befell us and to hear the gist of Troy’s last trial, even though I shrink from the memory and can barely face its pain, yet I will begin.’")])]), _vm._v(" "), _c('p', {
    staticClass: "align_right firstInSection"
  }, [_vm._v("Virgil, "), _c('em', [_vm._v("Aeneid")]), _vm._v(" II, 1–13")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 63
// module chunks = 0